export default __webpack_public_path__ + "static/icon-5-4-48f0c1f3bb7746d00b3ec957fbf431a6.png";